import { render, staticRenderFns } from "./submenu.vue?vue&type=template&id=af11bbe8&"
import script from "./submenu.vue?vue&type=script&lang=js&"
export * from "./submenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/ai-contact/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af11bbe8')) {
      api.createRecord('af11bbe8', component.options)
    } else {
      api.reload('af11bbe8', component.options)
    }
    module.hot.accept("./submenu.vue?vue&type=template&id=af11bbe8&", function () {
      api.rerender('af11bbe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LayoutComponents/Menu/MenuTop/partials/submenu.vue"
export default component.exports